import AddBtn from '../../components/common/AddBtn';
import DataTable from '../../components/common/DataTable';
import Pagination from '../../components/common/Pagination';

import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
  view_all_table,
} from '../../shared/enums/bankaccounts_enum';
import {
  useAllBankaccounts,
  useGetDropdownOptions,
} from '../../shared/hooks/UseBankaccount';
import CompactSidebarFilter from '../../utils/Compact-Sidebar-Filter';
import TableSection from '../../utils/table-section';
const AllBankaccounts = ({}) => {
  const [data, setPageNumber, deleteBtnClicked] = useAllBankaccounts();
  const {
    bankaccounts_loading,
    bankaccounts,
    total_bankaccounts,
    page,
    pages,
  } = data;
  const [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ] = useGetDropdownOptions();
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "client") {
    //   await setClientSearchField("name");
    //   await setClientSearchValue(inputValue);
    //   callback(dropdownOptions.client);
    // }
  };
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />

        <TableSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_data={total_bankaccounts}
          data={bankaccounts}
          data_loading={bankaccounts_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          deleteBtnClicked={deleteBtnClicked}
          view_all_table={view_all_table}
          inputFields={inputFields}
          PAGE_TITLE={PAGE_TITLE}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          LINK_URL={LINK_URL}
          DataTable={DataTable}
          TABLE_TITLE='Clients Management'
        />

        {/* <div className='container-fluid'>
          <div className='row'>
            {SIDEBAR_OPTIONS && (
              <CompactSidebarFilter
                SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
                dropdown_options={dropdownOptions}
                loadOptions={loadOptions}
              />
            )}
            <div className='col-lg-9'>
              <div
                className='card'
                style={{ boxShadow: 'rgb(227 233 243) 0px 4px 22px' }}
              >
                <div className='card-body'>
                  <AddBtn item={LINK_URL} title={PAGE_SINGLE_TITLE} />
                  {total_bankaccounts} records found
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={bankaccounts}
                      field={LINK_URL}
                      page={page}
                      deleteBtnClicked={deleteBtnClicked}
                      loading={bankaccounts_loading}
                      inputFields={inputFields}
                      PAGE_TITLE={PAGE_TITLE}
                      PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
                    />

                    <Pagination
                      data={bankaccounts}
                      page={page}
                      pages={pages}
                      count={total_bankaccounts}
                      setPage={setPageNumber}
                      loading={bankaccounts_loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AllBankaccounts;
